/*
 * @@Copyright (c): Knowdee All rights reserved.
 * @Description: config/query接口
 * @Author: wangwz@knowdee.com
 * @LastEditors: wangwz@knowdee.com
 * @Date: 2022-05-16 14:53:59
 * @LastEditTime: 2022-07-13 15:44:32
 * @FilePath: /client-h5-v2/src/apis/config/query.ts
 */
import httpRequest from '@/request/index'
import { ConfigQueryParams } from '@/apis/types'
import { apiGetLocalfiles } from '@/apis/config/applicationPropterty'

// 获取用户信息
export function apiGetConfigQuery (param: ConfigQueryParams) {
  if (window.botV2GlobalProperties.NODE_ENV === 'development') {
    return apiGetLocalfiles(`/${window.botV2GlobalProperties.BASE_PATH}/json/common/configQuery.json`)
  } else {
    return httpRequest({
      url: '/api/v1/config/query',
      method: 'post',
      data: param
    })
  }
}
